
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "viewer": "viewer-26cb4ab6",
    "fit": "fit-26cb4ab6",
    "view": "view-26cb4ab6",
    "visible": "visible-26cb4ab6"
};
exports.styleSource = ".viewer-26cb4ab6{position:relative}.viewer-26cb4ab6.fit-26cb4ab6{width:100%;height:100%}.viewer-26cb4ab6.fit-26cb4ab6>.view-26cb4ab6{height:100%}.viewer-26cb4ab6>.view-26cb4ab6{position:absolute;top:0;width:100%}.viewer-26cb4ab6>.view-26cb4ab6.visible-26cb4ab6{position:relative}.view-26cb4ab6{visibility:hidden;opacity:0;transition:all .2s ease}.view-26cb4ab6.visible-26cb4ab6{visibility:inherit;opacity:1}";
exports.default = exports.styles;
            
module.moduleType = "style";
